export type DataProps = {
  title: string;
  text: string;
  date: string;
  category: {
    tag: string;
    color: string;
  };
  link: {
    url: string;
    text: string;
  };
};

const data: DataProps[] = [
  {
    title: 'AWS Conference',
    text: 'In any moment of decision, the best thing you can do is the right thing, the next best thing is the wrong thing, and the worst thing you can do is nothing.',
    date: 'Jan 3 2020',
    category: {
      tag: 'critical',
      color: '#F04F47',
    },
    link: {
      url: '#',
      text: 'Read more',
    },
  },
  {
    title: 'Firebase',
    text: "Do what you love to do and give it your very best. Whether it's business or baseball, or the theater, or any field. If you don't love what you're doing and you can't give it your best, get out of it. Life is too short. You'll be an old man before you know it.",
    date: 'Jan 10 2020',
    category: {
      tag: 'heigh',
      color: '#F19B0C',
    },
    link: {
      url: '#',
      text: 'Read more',
    },
  },
  {
    title: 'Crema Launch',
    text: 'To be nobody but yourself in a world which is doing its best, night and day, to make you everybody else - means to fight the hardest battle which any human being can fight; and never stop fighting.',
    date: 'Jan 20 2020',
    category: {
      tag: 'medium',
      color: '#0A8FDC',
    },
    link: {
      url: '#',
      text: 'Read more',
    },
  },
  {
    title: 'First Update',
    text: 'In any moment of decision, the best thing you can do is the right thing, the next best thing is the wrong thing, and the worst thing you can do is nothing.',
    date: 'Feb 03 2020',
    category: {
      tag: 'normal',
      color: '#018f69',
    },
    link: {
      url: '#',
      text: 'Read more',
    },
  },
];
export default data;
